<template>
  <el-dialog :visible.sync="dialogVisible" width="480px" :close-on-click-modal="false" @close="close">
    <div slot="title">{{ $t('stores::products-info::batch_edit') }}</div>
    <el-form label-position="right" label-width="120px">
      <el-form-item :label="$t('stores::products-info::first_stock') + '：'">
        <el-input-number
          class="input-width"
          controls-position="right"
          v-model="edHeader.skuInventory"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('stores::products-info::weight') + '：'">
        <el-input-number class="input-width" controls-position="right" v-model="edHeader.weight"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('stores::products-info::purchase_price') + '：'">
        <el-input-number
          class="input-width"
          controls-position="right"
          v-model="edHeader.purchasePrice"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('stores::products-info::compare_at_price') + '：'">
        <el-input-number
          class="input-width"
          controls-position="right"
          v-model="edHeader.compareAtPrice"
        ></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('stores::products-info::sale_price') + '：'">
        <el-input-number class="input-width" controls-position="right" v-model="edHeader.salePrice"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="close">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button @click="save" type="primary">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    }
  },
  data() {
    return {
      edHeader: {
        skuInventory: '',
        purchasePrice: '',
        compareAtPrice: '',
        salePrice: '',
        weight: ''
      },
      dialogVisible: false
    }
  },
  watch: {
    visible(bool) {
      this.dialogVisible = bool
      if (!bool) {
        this.edHeader = {
          skuInventory: '',
          purchasePrice: '',
          compareAtPrice: '',
          salePrice: '',
          weight: ''
        }
      } else {
      }
    }
  },
  methods: {
    save() {
      this.$emit('edit', this.edHeader)
      this.close()
    },
    close() {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.input-width {
  width: 250px;
}
</style>
